/**
 * @Injectable
 * All services for dock model
 *
 * Extends SettingService
 *
 */

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import { Dock } from '../models/dock.model';
import { HttpService } from './http.service';

@Injectable()

export class DockService /*extends SettingService implements OnInit*/ {

    private apiModelUrl = environment.apiUrl + 'dock/';

    public slug = 'dock';
    public title = 'Lanceur d\'applications';
    public label = '';
    public id = 1;
    public url;
    public icon;
    public position;

    setBlank1(): Dock {
        return {
            id: this.id,
            label: this.label,
            url: this.url,
            icon: this.icon,
            position: this.position
        }
    };

    constructor(
        private http: HttpService
    ) { }

    //ngOnInit() {
    //    //console.log(this.getUrl());
    //}

    /**
    * Get a Dock instance built from the setting found by its id
    *
    * @param		  {Number}           the id of the setting to retrieve
    * @return		{SettingPage}      the setting page with the setting found
    */
    getOneDock(id: number): Promise<Dock> {
        return this.http.get(this.apiModelUrl + id)
            .toPromise()
            .then(response => response.json());
    }

    /**
    * Get all Docks instances
    *
    * @return		{SettingPage}      the setting page with the setting found
    */
    getAllDocks(): Promise<Dock[]> {
        return this.http.get(this.apiModelUrl)
            .toPromise()
            .then(response => response.json());
    }

    saveOneDock(Dock): Promise<Dock> {
        return this.http.post(this.apiModelUrl + 'replaceOrCreate', Dock)
            .toPromise()
            .then(response => response.json());
    }

    delete(DockId): Promise<Dock[]> {
        return this.http.delete(this.apiModelUrl + DockId + '/delete')
            .toPromise()
            .then(response => response.json());
    }

    /**
       * Get instances of the current Domain
     *
     * @param		  {String}       an optionnal query string
       * @return		{Promise}      Array of all instances found
     */
    //getDomainItems(query?: string): Promise<Domain[]> {
    //    query = (query ? '?filter=' + encodeURIComponent(JSON.stringify({ where: { label: { ilike: query + '%' } } })) : '');
    //    return this.http.get(this.getUrl() + query)
    //        .toPromise()
    //        .then(response => response.json());
    //}

}



// WEBPACK FOOTER //
// ./src/app/shared/services/dock.service.ts